import { render, staticRenderFns } from "./viewmap.vue?vue&type=template&id=89d5670c&scoped=true&"
import script from "./viewmap.vue?vue&type=script&lang=js&"
export * from "./viewmap.vue?vue&type=script&lang=js&"
import style0 from "./viewmap.vue?vue&type=style&index=0&id=89d5670c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d5670c",
  null
  
)

export default component.exports